import React, { useEffect, useContext } from "react"
import {
  MainContainer,
  MainContainerHeader,
  MainContainerMessage,
} from "./commonStyles"
import { HorizontalSpacer } from "@omnichannel/ace-b2b-elements"
// import UrlParamsContext from "../../context/UrlParamsContext"
// import { getAppInfo } from "../../helpers/utils"

const PageBodyWrapper = props => {
  const urlParams = ''//useContext(UrlParamsContext)
  // const appId = urlParams?.appId

  // useEffect(() => {
  //   const app = getAppInfo(appId)

  //   const oldLink = document.querySelectorAll('[rel="icon"]')[0]
  //   document.head.removeChild(oldLink)

  //   const link = document.createElement('link')
  //   link.rel = "icon"
  //   link.href = app.favicon
  //   document.head.appendChild(link)
  // })

  return (
    <MainContainer>
      {props && props.title && (
        <>
          <MainContainerHeader>{props.title}</MainContainerHeader>
          <HorizontalSpacer height="1.2rem" />
        </>)
      }
      {props.message && (
        <MainContainerMessage>{props.message}</MainContainerMessage>
      )}
      {props.children}
    </MainContainer>
  )
}

export default PageBodyWrapper
